import { legacyPlugins } from "/tmp/build_ea07ccf6/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}